import Termly from 'termly-namespace'

import CookieConsents from 'utils/cookieConsents'
import { makeSaveConsent } from 'utils/tcf-gvl'

import validateMessage from './validateMessage'


/**
 * @param {string} masterOrigin - the origin from which we're syncing consent config
 *
 * @returns {Function}
 */
export default function makeOnMessageHandler(masterOrigin) {
  /**
   * An event handler that only responds to messages that have
   * the expected `event.data.source` and whose `event.orgin`
   * exactly matches `masterOrigin`.
   *
   * @param {MessageEvent} event
   * @param {object} event.data
   * @param {object} event.data.payload
   * @param {object} event.data.payload.consents
   * @param {string} event.data.source
   * @param {object} event.origin
   */
  return ({ data, origin }) => {
    const {
      payload,
      source,
    } = data

    const isValidMessage = validateMessage({
      masterOrigin,
      origin,
      payload,
      source,
    })

    if ( !isValidMessage ) {
      return
    }

    const {
      ccVersion: masterCCVersion,
      consents: masterConsents,
    } = payload

    if ( CookieConsents.hasConsents() ) {
      const localConsents = CookieConsents.getConsents()

      if ( localConsents.id === masterConsents.id ) {
        console.debug('Not reloading...consents from master are the same as the locally-stored consents')
        return
      }

      if ( localConsents.id > masterConsents.id ) {
        console.info('Keeping newer local consent settings (master:%s <= local:%s)',
                     masterConsents.id,
                     localConsents.id)
        return
      }
    }

    console.info('Setting cookie consents from %o: %o', masterOrigin, payload.consents)

    CookieConsents.setConsents(masterConsents)

    if ( Termly.tcf ) {
      const saveTCFConsent = makeSaveConsent({
        ccVersion: masterCCVersion,
        cmpApi: Termly.tcf.cmpApi,
      })

      saveTCFConsent(masterConsents.tc_string)
    }

    // TODO: It seems to me that we should be doing our reloads intelligently using
    // needsFullPageReload(), but nobody's complaining about the status quo, and
    // that's out of scope for now.
    window.location.reload()
  }
}
